module.exports = __webpack_public_path__ + "static/media/log-out.10cd3f95.svg";